/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isSymbolType
 */

export default function isSymbolType(value) {
  return typeof value === 'symbol';
}
